import thumbnail from './thumbnail.png';
import Mediator from './Mediator';

export default {
    handle: 'courseWrapper',
    label: 'Course Wrapper',
    thumbnail,
    mediatorComponent: Mediator,
};
